<template>
    <v-navigation-drawer
        right
        fixed
        temporary
        stateless
        v-model="drawer"
        :width="width">
        <v-card-actions class="right-panel-header pa-4">
            <div class="title font-weight-bold">{{ title }}</div>
            <v-spacer/>
            <slot name="headerAction"/>
            <v-btn
                icon
                @click="close">
                <icon
                    value="close"/>
            </v-btn>
        </v-card-actions>
        <v-divider/>

        <div class="right-panel-content">
            <slot name="content" v-bind:context="context"/>
        </div>

        <v-card-actions
            v-if="!hideBottom"
            class="right-panel-bottom px-4 py-3">
            <slot name="bottom" v-bind:context="context"/>
        </v-card-actions>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: 'RightPanel',

    props: {
        title: {
            type: String,
            default: ''
        },

        width: {
            type: String,
            default: '600px'
        },

        hideBottom: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            drawer: false,
            context: null
        }
    },

    methods: {
        open (context) {
            this.context = context
            this.drawer = true
        },

        close () {
            this.drawer = false
        }
    }
}
</script>

<style lang="scss" scoped>
.right-panel-content {
    min-height: calc(100% - 70px);
    padding-bottom: 70px;
}
.right-panel-bottom {
    border-top: 1.2px solid #00000036;
    background: white;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
}
</style>
